import React from 'react'
import img2031 from '../components/images/dglowroad.png'

const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2031} alt='glowroad' />
            </div>
            <div className="row m-2">
                <div className="col-sm ">

                    <h2 className='p-2'>GlowRoad Account Management Overview
                    </h2>
                    <p>Optimize your sales on GlowRoad with our specialized account management services designed to enhance your presence and profitability on the platform. </p>
                </div>
                <div className="col-sm ">
                    {/* <img src={img201} alt='Queryimg' /> */}
                </div>
            </div>
            <ul >
                <h3 className='text-info'> Key Services We Offer:</h3>
                <li><b>•	Product Listing:</b> Create detailed and well-organized listings with accurate descriptions, quality images, and strategic keywords. </li>
                <li><b>•	Advertising Campaign:</b>Plan targeted ads to boost product visibility and drive sales through GlowRoad’s networks. </li>
                <li><b>•	Coupons:</b>Develop and manage discount coupons to promote purchases and encourage customer loyalty. </li>
                <li><b>•	Brand Registry:</b>Assist in brand registration to protect intellectual property and enhance brand presence. </li>
                <li><b>•	Brand Approval:</b> Streamline the process for brands to get approval to sell on GlowRoad, ensuring compliance. </li>
                <li><b>•	Category Approval:</b> Simplify the approval process for specific or restricted categories. </li>
                <li><b>•	Account Health:</b> Maintain the overall health of your GlowRoad account, ensuring compliance with policies and key metrics. </li>
                <li><b>•	Order Processing:</b> Manage the entire order process from receipt to delivery for efficient fulfillment. </li>
                <li><b>•	Payment Reconciliation:</b> Record transactions accurately and resolve any discrepancies promptly. </li>
                <li><b>•	Keyword Optimization:</b> Optimize keywords to improve search visibility and attract more customers. </li>
                <li><b>•	Safety Claim:</b> Address product safety issues and ensure compliance while handling customer concerns. </li>
                <li><b>•	Basic Training:</b>Provide essential training to effectively manage your GlowRoad account. </li>
                <li><b>•	Sales Boost:</b> Implement strategies to enhance sales, including product promotion and optimized advertising.</li>
            </ul>
        </>
    )
}

export default events